// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__tPD2I","bigColWidth":"Table_bigColWidth__O4Q00","biggerColWidth":"Table_biggerColWidth__1GXBy","row":"Table_row__2mzma","col":"Table_col__wWSPg"};